import React, { useEffect, useRef, useState } from "react";
import "./CreateMultiVoteCard.scss";
import xlogo from "../../../assets/icons/x.svg";
import HeaderElement from "../../HeaderElement/HeaderElement";
import strings from "../../../locales/ro.json";
import PillButton from "../../Buttons/PillButton/PillButton";
import SendVote from "../../Buttons/SendVote/SendVote";
import Dropdown from "../CreateVoteCard/dropdown";
import { UserAuth } from "../../../context/AuthContext";
import { useApi } from "../../../hooks/useApi";
import StandardPopup from "../../Global/StandardPopup/StandardPopup";
import popupicon from "../../../assets/icons/createVotPopup.svg";
import { useNavigate } from "react-router-dom";

const CreateMultiVoteCard = ({ className, style, options, handleOptions }) => {

    const questionRef = useRef(null);
    const { user } = UserAuth();
    const { api } = useApi();
    const { abstainText, questionPlaceholderText, addOptionText, removeOptionText } = strings.createVote;
    const inputRefs = useRef([]);
    const optionArray = options?.options ? options.options : [];
    const [popupOpen, setPopupOpen] = useState(false);
    const [popupFunction, setPopupFunction] = useState(() => { });
    const [namesList, setNamesList] = useState("");
    const [groupArray, setGroupArray] = useState([]);

    const setOptionArray = (value) => {
        handleOptions({ ...options, options: [...value] });
    };
    const navigate = useNavigate();
    useEffect(() => {
        optionArray.map((item, i) => {
            if (inputRefs.current[i])
                inputRefs.current[i].value = item;
            return "";
        });
    }, [optionArray]);

    useEffect(() => {
        api("groups", "GET")
            .then((result) => {

                setGroupArray([...result?.map((item) => {
                    return { value: item.id, label: item.name }
                })
                ]);
            });
    }, [api]);

    const addOptionOnLoseFocus = (event) => {
        if (event.target.value === "") return;
        let initialOptionValue = event.target.value;
        let finalOptionValue =
            initialOptionValue.charAt(0).toUpperCase() + initialOptionValue.slice(1);
        let newArray = [];
        newArray = [...optionArray, finalOptionValue];
        event.target.value = "";
        setOptionArray(newArray);
    };

    const editOptionOnLoseFocus = (event, index) => {
        let newOptions = optionArray;
        newOptions = [...newOptions];

        if (event.target.value) newOptions[index] = event.target.value;
        else newOptions.splice(index, 1);
        setOptionArray(newOptions);
    };

    const handleOptionKeyDown = (event, index) => {
        if (event.keyCode === 13) {
            if (index === -1) {
                if (event.target.value === "") return;
                let initialOptionValue = event.target.value;
                let finalOptionValue =
                    initialOptionValue.charAt(0).toUpperCase() +
                    initialOptionValue.slice(1);
                setOptionArray([...optionArray, finalOptionValue]);
            }
            else {
                let newOptions = optionArray;
                newOptions = [...newOptions];

                if (event.target.value)
                    newOptions[index] = event.target.value;
                else newOptions.splice(index, 1);
                setOptionArray(newOptions);
            }
            event.target.value = "";
        }
    };

    const sanityCheck = () => {
        if (!options) return false;
        if (!options.question) return false;
        if (!options.options) return false;
        if (options.options.length === 0) return false;
        if (!options.voteType) return false;
        if (options.isMultipleChoice === undefined) return false;
        if (options.isSecret === undefined) return false;
        if (!options.title) return false;
        if (options.question.includes("$$$")) return false;
        if (options.title.includes("$$$")) return false;
        if (options.group === undefined) return false;
        if (!options.title.includes("$USER")) return false;
        if (!namesList || namesList.trim().length === 0) return false;

        return true;
    }

    return (
        <div className={`voteFormBG ${className}`} style={style}>
            <StandardPopup message={strings.createVote.createvotePopup} icon={popupicon} yesFcn={popupFunction} noFcn={() => { setPopupOpen(false) }} isOpen={popupOpen} />

            <HeaderElement
                placeholder={questionPlaceholderText}
                headerText={options?.title ? options.title : ""}
                inputHandler={handleOptions}
            />
            <div style={{ fontSize: '12px', color: 'gray', marginTop: '10px', marginBottom: '10px', textAlign: 'center' }}>
                Trebuie sa incluzi <b>$USER</b> in titlu unde vrei sa apara numele persoanei.
            </div>

            <PillButton
                className="marginTop"
                options={strings.createVote.voteSecrecyTypes}
                handleInput={(value) => { handleOptions({ ...options, isSecret: value }) }}
                chosen={options.isSecret}
            />
            <PillButton
                className="marginTop"
                options={strings.createVote.choiceTypes}
                handleInput={(value) => { handleOptions({ ...options, isMultipleChoice: value }) }}
                chosen={options.isMultipleChoice}
            />
            <PillButton
                className="marginTop"
                options={strings.createVote.voteTypes}
                handleInput={(value) => { handleOptions({ ...options, voteType: value }) }}
                chosen={options.voteType}
            />
            <Dropdown isInitialGAV={options.group === 'GAV'} options={[
                { value: 'GAV', label: 'Vot de Adunare Generala' },
                ...groupArray
            ]} onSelect={(value) => { handleOptions({ ...options, group: value }) }} />

            <label className="namesLabel">Lista Persoane (unul pe linie)</label>
            <textarea
                className="namesInput"
                placeholder="Ion Popescu&#10;Maria Ionescu&#10;..."
                value={namesList}
                onChange={(e) => setNamesList(e.target.value)}
            />

            <input
                type="text"
                ref={questionRef}
                placeholder={questionPlaceholderText}
                defaultValue={options.question}
                className="questionInput"
                onChange={(event) =>
                    handleOptions({ ...options, question: event.target.value })
                }
                onFocus={() => {
                    const patternIndex = options.question ? options.question.indexOf("$$$") : -1;
                    if (patternIndex !== -1) {
                        questionRef.current.setSelectionRange(patternIndex, patternIndex + 3);
                    }
                }}
            >

            </input>
            <div>

                <div className="voteOptions">
                    {optionArray.map((item, i) => {
                        return (
                            <div key={i}>
                                <input type={options.isMultipleChoice ? "checkbox" : "radio"} name="option" disabled={true} />
                                <input
                                    type="text"
                                    className="optionInput"
                                    placeholder={removeOptionText}
                                    onKeyDown={(event) => {
                                        handleOptionKeyDown(event, i);
                                    }}
                                    onBlur={(event) => {
                                        editOptionOnLoseFocus(event, i);
                                    }}
                                    ref={(el) => (inputRefs.current[i] = el)}
                                />
                                <img
                                    src={xlogo}
                                    alt="close"
                                    style={{ cursor: 'pointer' }}
                                    onClick={() => {
                                        handleOptionKeyDown(
                                            { keyCode: 13, target: { value: "" } },
                                            i
                                        );
                                    }}
                                />
                            </div>
                        );
                    })}
                    <div className="optionInput1">
                        <input type={options.isMultipleChoice ? "checkbox" : "radio"} name="option" disabled={true} />
                        <input
                            type="text"
                            className="optionInput"
                            placeholder={addOptionText}
                            onKeyDown={(event) => {
                                handleOptionKeyDown(event, -1);
                            }}
                            onBlur={(event) => {
                                addOptionOnLoseFocus(event);
                            }}
                        />
                    </div>
                    {!(options.group === 'GAV') ? null : (<div className="voteOption">
                        <input type={options.isMultipleChoice ? "checkbox" : "radio"} name="option" disabled={true} />
                        <input
                            type="text"
                            className="optionInput disabled"
                            defaultValue={abstainText}
                        />
                    </div>)}
                </div>

                <div className="CreateVoteSendButton">
                    <SendVote enabled={sanityCheck()} onClickFunction={
                        () => {
                            if (!sanityCheck()) return;

                            setPopupFunction((prevFcn) => {
                                return async () => {
                                    setPopupOpen(false);
                                    const names = namesList.split('\n').map(n => n.trim()).filter(n => n.length > 0);

                                    try {
                                        const promises = names.map(async (name) => {
                                            let finalOptions = [...options.options];
                                            if (options.group === 'GAV')
                                                finalOptions.push(abstainText);

                                            const title = options.title.split('$USER').join(name);
                                            const questionText = options.question.split('$USER').join(name);

                                            let body = {
                                                uid: 1,
                                                title: title,
                                                question: {
                                                    text: questionText,
                                                    options: finalOptions,
                                                    isMultipleChoice: options.isMultipleChoice,
                                                    voteCountingRule: options.voteType
                                                },
                                                voteGroupID: options.group === 'GAV' ? 0 : options.group,
                                                viewGroupID: options.group === 'GAV' ? 0 : options.group,
                                                isGeneralAssemblySplitVote: options.group === 'GAV',
                                                showVotesPublicly: !options.isSecret
                                            };

                                            return api("ballots", "PUT", body);
                                        });

                                        await Promise.all(promises);
                                        navigate("/");
                                    } catch (e) {
                                        console.error("Error creating votes", e);
                                        alert("A apărut o eroare la crearea voturilor.");
                                    }
                                };
                            });
                            setPopupOpen(true);
                        }}
                    />
                </div>
            </div>
        </div>
    );
};

export default CreateMultiVoteCard;
